"use client";

import { History, Power } from "lucide-react";

export type VoiceFooterProps = {
  /** 未指定ならログボタンを出さない。対話ログを常時表示しているウィジェット用 */
  onShowLog?: () => void;
  onEndSession: () => void;
};

export default function VoiceFooter({
  onShowLog,
  onEndSession,
}: VoiceFooterProps) {
  return (
    <div className="flex items-center justify-end gap-2 border-t border-[#e99bad]/5 px-4 py-3">
      {onShowLog && (
        <button
          onClick={onShowLog}
          className="mr-auto flex items-center gap-2 rounded-lg bg-slate-100 px-4 py-2 text-sm font-medium text-slate-600 transition-colors hover:bg-slate-200"
        >
          <History className="h-4 w-4" />
          対話ログを見る
        </button>
      )}
      <button
        onClick={onEndSession}
        className="flex items-center gap-2 rounded-lg bg-[#ff4d4d] px-4 py-2 text-sm font-medium text-white shadow-sm transition-colors hover:bg-[#e64545]"
      >
        <Power className="h-4 w-4" />
        セッションを終了
      </button>
    </div>
  );
}
